import createAction from 'redux-actions/lib/createAction';
import tokens from '@spotify-internal/tokens';
import { SET_VIEWPORT } from '../actionTypes';

export const VIEWPORT_XS = parseInt(tokens.screenXs, 10);
export const VIEWPORT_SM = parseInt(tokens.screenSm, 10);
export const VIEWPORT_MD = parseInt(tokens.screenMd, 10);
export const VIEWPORT_LG = parseInt(tokens.screenLg, 10);
export const VIEWPORT_XL = parseInt(tokens.screenXl, 10);

export const setViewport = createAction(SET_VIEWPORT, viewport => {
  switch (viewport) {
    case VIEWPORT_XS:
    case VIEWPORT_SM:
    case VIEWPORT_MD:
    case VIEWPORT_LG:
    case VIEWPORT_XL:
      return viewport;
    default:
      return new Error('viewport not supported');
  }
});
